export default __webpack_public_path__ + "static/media/1b.0ce64f01.jpg";